export default {
  title: 'Cambia password',
  form: {
    email: {
      label: 'Email',
      placeholder: 'Inserisci email',
    },
    new_password: {
      label: 'Nuova password',
      placeholder: 'Inserisci password',
      requirements: 'La password deve contenere 8 caratteri, una lettera maiuscola e un numero',
    },
    confirm_password: {
      label: 'Conferma nuova password',
      placeholder: 'Conferma password',
    },
    error_messages: {
      missing_info: 'Informazioni mancanti',
    },
  },
  buttons: {
    change_password: 'Cambia password',
  },
};
